export const validateEmail = (value) => {
  const trimmed = value.trim();
  if (!trimmed) return 'validationEmailRequired';

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(trimmed)) return 'validationEmailInvalid';

  return '';
};

export const validatePassword = (value) => {
  if (!value) return 'validationPasswordRequired';
  if (value.length < 8) return 'validationPasswordLength';

  return '';
};
